<template>
  <el-dialog :title="title" :visible.sync="visible" v-bind="$attrs">
    <slot></slot>
    <slot name="footer" slot="footer">
      <div v-if="hasFooter">
        <el-button type="button" @click="visible = false">取 消</el-button>
        <el-button type="button" @click="confirm">确 定</el-button>
      </div>
    </slot>
  </el-dialog>
</template>

<script>
const noop = function () { }

export default {
  name: 'NyDialog',
  props: {
    value: {
      required: true
    },
    title: String,
    confirm: {
      type: Function,
      default: noop
    },
    hasFooter: Boolean
  },
  data () {
    return {
      visible: this.value
    }
  },
  watch: {
    value (newVal) {
      this.visible = newVal
    },
    visible (newVal) {
      this.$emit('input', newVal)
      this.$emit('change', newVal)
    }
  }
}
</script>
